import { useEffect, useRef, type ReactNode } from 'react';

/** 네이티브 <dialog> 모달. open=false면 내용을 그리지 않는다. Esc로 닫으면 onClose. */
export function Modal({ open, onClose, title, children }: { open: boolean; onClose: () => void; title: string; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);
  useEffect(() => {
    const dialog = ref.current;
    // 이전 close 이벤트가 다시 연 뒤에 도착할 수 있어 실제로 닫혀 있을 때만 처리한다.
    const handle = () => {
      if (!dialog?.open) onClose();
    };
    dialog?.addEventListener('close', handle);
    return () => dialog?.removeEventListener('close', handle);
  }, [onClose]);
  return (
    <dialog ref={ref}>
      {open && (
        <>
          <div className="card-head">
            <h2>{title}</h2>
            <button type="button" className="close" aria-label="닫기" onClick={onClose}>
              ×
            </button>
          </div>
          {children}
        </>
      )}
    </dialog>
  );
}

/** 분류 선택(대분류 → 소분류). 활성 항목만, 단 currentIds의 보관 항목은 유지 표시. */
export function CategoryPicker({
  tops,
  subs,
  categoryId,
  subcategoryId,
  onChange,
  labels = ['대분류', '소분류']
}: {
  tops: { id: string; name: string; active: boolean }[];
  subs: { id: string; name: string; active: boolean }[];
  categoryId: string;
  subcategoryId: string;
  onChange: (categoryId: string, subcategoryId: string) => void;
  labels?: [string, string];
}) {
  return (
    <>
      <label>
        {labels[0]}
        <select value={categoryId} onChange={(e) => onChange(e.target.value, '')} required>
          <option value="">선택 필요</option>
          {tops.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
              {c.active ? '' : ' (삭제됨)'}
            </option>
          ))}
        </select>
      </label>
      <label>
        {labels[1]}
        <select value={subcategoryId} onChange={(e) => onChange(categoryId, e.target.value)} required disabled={!categoryId}>
          <option value="">선택 필요</option>
          {subs.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
              {c.active ? '' : ' (삭제됨)'}
            </option>
          ))}
        </select>
      </label>
    </>
  );
}
